import { z } from 'zod';

export const SubscriberSchema = z.object({
  id: z.number(),
  email: z.string(),
});

export const SubscribersListResponseSchema = z.object({
  data: z
    .object({
      items: z.array(SubscriberSchema),
      totalItems: z.number().optional(),
    })
    .nullish(),
});

export const ListSubscribersQuerySchema = z.object({
  integrationUrn: z.string(),
});

export const CreateSubscriberRequestSchema = z.object({
  integrationUrn: z.string(),
  email: z.string(),
});

export const CreateSubscriberResponseSchema = z.object({
  data: z
    .object({
      items: z.array(SubscriberSchema),
    })
    .nullish(),
});

export const SubscriberErrorType = {
  AlreadyExists: 'GhostPlatformSubscriberAlreadyExistsError',
  UnresolvableIntegrationUrn: 'UnresolvableIntegrationUrnError',
  NotFound: 'GhostPlatformSubscriberNotFoundError',
} as const;

export type Subscriber = z.infer<typeof SubscriberSchema>;
export type CreateSubscriberRequest = z.infer<
  typeof CreateSubscriberRequestSchema
>;
export type SubscriberErrorType =
  (typeof SubscriberErrorType)[keyof typeof SubscriberErrorType];
